'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireStatus = void 0;
var QuestionnaireStatus;
(function (QuestionnaireStatus) {
    QuestionnaireStatus["REQUESTED"] = "Requested";
    QuestionnaireStatus["SUBMITTED"] = "Submitted";
    QuestionnaireStatus["VERIFIED"] = "Verified";
    QuestionnaireStatus["REJECTED"] = "Rejected";
    QuestionnaireStatus["EXPIRED"] = "Expired";
})(QuestionnaireStatus = exports.QuestionnaireStatus || (exports.QuestionnaireStatus = {}));
